(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bis-form"]) return;
  try {
    
  if(!customElements.get('bis-modal')) {
    class bisModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.bisForm = this.querySelector('form');
        this.productTitle = this.querySelector('[data-product-title]');
        this.variantName = this.querySelector('[data-product-variant]');
        this.variantId = this.querySelector('[data-bis-variant-id]');
        this.productId = this.querySelector('[data-bis-product-id]');
        this.bisTypeSelectors = this.querySelectorAll('input[type="radio"]');
        this.closeButton = this.querySelector('[data-close-button]');
        this.newsletterCheckbox = this.querySelector('[data-consent-checkbox]');
        this.smsDisclaimer = this.querySelector('[data-sms-disclaimer]');
        this.zipCodeField = this.querySelector('[data-zip-code-field]');
        this.bisButton = document.querySelector('[is="bis-button"]');
        this.variantStatus = document.querySelector('[data-variant-status]');
        this.productIdEl = document.querySelector('[data-block-type="buy-buttons"] [name="id"]')
        this.buyButton = document.querySelector('buy-buttons [type="submit"]');
      }

      connectedCallback() {
        document.addEventListener('bisForm:open', this.openModal.bind(this));
        if(!this.variantStatus) {
          return;
        }
        this.variantList = JSON.parse(this.variantStatus?.innerHTML)

        this.bisTypeSelectors.forEach((radio) => {
          radio.addEventListener('change', (evt) => {
            let emailAction = 'remove';
            let smsAction = 'add';
            if(evt.target.value == 'sms') {
              emailAction = 'add';
              smsAction = 'remove';
            }
            this.querySelector('input[type="email"]').classList[emailAction]('hidden');
            this.querySelector('input[type="tel"]').closest('.iti').classList[smsAction]('hidden');
            this.smsDisclaimer.classList[smsAction]('hidden');
          })
        })

        this.bisForm?.addEventListener('submit', this.submitModal.bind(this));
        this.closeButton.addEventListener('click', this.closeModal.bind(this));
        this.bisButton.addEventListener('click', this.onBisButtonClick.bind(this));
        document.addEventListener('variant:change', this.onVariantChange.bind(this));
        this.klaviyoPublicKey = this.getKlaviyoPublicKey();
        this.reviewBisButtonStatus()
      }

      getKlaviyoPublicKey = () => {
        const script = Array.from(document.scripts).find(s =>
          s.src.includes("static.klaviyo.com/onsite/js/")
        );
        if (!script) return null;

        const match = script.src.match(/onsite\/js\/([^/]+)\/klaviyo\.js/);
        return match ? match[1] : null;
      }

      openModal(evt) {
        const info = evt.detail;

        this.productTitle.innerText = info.productTitle;
        this.variantName.innerText = info.variantTitle;
        this.productId.value = info.productId;
        this.variantId.value = info.variantId;

        this.dialog.showModal();
      }

      closeModal() {
        this.dialog.close();
      }

      submitModal(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const formValid = this.validateFormFields();

        if(!formValid) {
          this.updateFormMessage({
            message: "All fields are required",
            success: false,
          })

          return;
        }

        const zipCode = this.zipCodeField.value;

        const payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: [],
              profile: {
                data: {
                  type: "profile",
                  attributes: {},
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${this.variantId.value}`,
                },
              },
            },
          },
        };

        const updatePayload = {
          data: {
            type: "profile",
            attributes: {
              properties: {},
            }
          }
        }

        const email = this.bisForm.querySelector('input[type="email"').value;

        payload.data.attributes.channels.push("EMAIL");
        payload.data.attributes.profile.data.attributes.email = email;
        updatePayload.data.attributes.email = email;

        if(zipCode) {
          updatePayload.data.attributes.properties["zip-code"] = zipCode;
        }

        fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.klaviyoPublicKey}`,
          {
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2025-04-15",
            },
            method: "post",
            body: JSON.stringify(payload),
          }
        ).then(async (data) => {
          if (data.status == 202) {
            await fetch(`https://a.klaviyo.com/client/profiles?company_id=${this.klaviyoPublicKey}`, {
                headers: {
                  accept: "application/vnd.api+json",
                  "content-type": "application/vnd.api+json",
                  revision: "2025-07-15"
                },
                method: "post",
                body: JSON.stringify(updatePayload)
              })

              this.updateFormMessage({
                message: "We'll Notify You When It's Back In Stock",
                success: true,
              })
          } else {
            const response = await data.json();
            const errorsMsg = await response.errors.map((error) => {
              return error.detail;
            });

            this.updateFormMessage({
              message: errorsMsg.join('<br/>'),
              suicces: false
            })
          }
        });
      }

      updateFormMessage({
        message,
        success
      }) {
        const confirmMessage = this.querySelector("[data-confirm-message]");
        const successIcon = this.querySelector(".bis-modal-form__confirm-message svg");

        if(!success) {
          successIcon.style.display = "none";
          confirmMessage.style.color = "rgb(var(--error-text))"
        }

        confirmMessage.innerHTML = message;
        confirmMessage.parentElement.removeAttribute('hidden');

        setTimeout(() => {
          confirmMessage.parentElement.setAttribute('hidden', true);
          confirmMessage.removeAttribute('style');
          successIcon.removeAttribute('style');
        }, 5000);
      }

      reviewBisButtonStatus() {
        if(!this.bisButton) {
          return;
        }

        const selectedId = this.productIdEl.value;
        const currentIdObject = this.variantList[selectedId];

        if(currentIdObject.available) {
          this.hideBisButton();
        } else {
          this.showBisButton();
        }
      }

      showBisButton() {
        this.buyButton.style.display = "none";
        this.buyButton.setAttribute('disabled', true);
        this.bisButton.removeAttribute('hidden');
      }

      hideBisButton() {
        this.buyButton.style.display = "block";
        this.buyButton.removeAttribute('disabled');
        this.bisButton.setAttribute('hidden', true);
      }

      onVariantChange(evt) {
        const variantDetail = evt.detail;

        if(variantDetail.variant.available) {
          this.hideBisButton();
        } else {
          this.showBisButton();
        }
      }

      validateFormFields() {
        const fields = Array.from(this.querySelectorAll('input[required]'));
        let validForm = true;

        fields.forEach((field) => {
          const isValid = field.checkValidity();

          if(!isValid) {
            field.classList.add('has-error');
            field.addEventListener('keyup', (evt) => {
              evt.target.classList.remove('has-error')
            }, {once: true})

            if(validForm) {
              field.focus();
            }

            validForm = false;
          }
        })

        return validForm;
      }

      onBisButtonClick() {
        const selectedId = this.productIdEl.value;
        const currentIdObject = this.variantList[selectedId];

        document.dispatchEvent(new CustomEvent('bisForm:open', {
          detail: {
            variantId: selectedId,
            variantTitle: currentIdObject.title,
            productTitle: currentIdObject.productTitle,
          }
        }))
      }
    }

    customElements.define('bis-modal', bisModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-preview')) {
    class VideoPreview extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.io = new IntersectionObserver(this.observerCallback.bind(this), {
          rootMargin: '300px',
          threshold: ['0', '0.01'],
        });
        this.overlayVideo = this.querySelector('[data-overlay-video]');
        this.fullVideo = this.querySelector('[data-full-video]');
        this.playButton = this.querySelector('.video-preview__play-button');
        this.videoPlaying = false;

        this.playButton.addEventListener('click', this.playVideo.bind(this), {
          signal: this.abortController.signal
        })

        this.fullVideo.addEventListener('pause', this.pauseVideo.bind(this, {playOverlay: true}), {
          signal: this.abortController.signal
        })
        this.io.observe(this);
      }

      observerCallback(entries) {
        entries.forEach((entry) => {
          if(!entry.isIntersecting) {
            if(this.videoPlaying) {
              this.pauseVideo({playOverlay: false});
            } else {
              this.overlayVideo.pause();
            }
          } else {
            if(this.overlayVideo) {
              this.overlayVideo.play();
            }
          }
        });
      }

      pauseVideo({playOverlay}) {
        if(this.fullVideo.ended == true) return;

        this.fullVideo.pause();
        this.classList.remove('is-playing');
        this.videoPlaying = false;

        if (this.overlayVideo && playOverlay == true) {
          this.overlayVideo.play();
          this.playButton.focus();
        }
      }

      playVideo() {
        if (this.overlayVideo) {
          this.overlayVideo.pause();
        }

        this.classList.add('is-playing');
        this.fullVideo.play();
        this.fullVideo.focus();
        this.videoPlaying = true;
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('video-preview', VideoPreview);
  }

  } catch(e) { console.error(e); }
})();
})();
